<template>
  <section class="banner__area pt-20 pb-10 ad-banner-section ad-banner-section--interactive">
    <div class="container">
      <div class="row">
        <div
          v-for="t in activeBannerTypes123"
          :key="t"
          class="col-xl-4 col-lg-4 col-md-6"
        >
          <div class="ad-banner-3d">
            <AdBannerMouse3d>
              <div class="ad-banner-3d__inner">
                <div
                  class="banner__item p-relative w-img mb-30 ad-banner-3d__card ad-banner-showcase ad-rotate-swap ad-banner-vertical"
                  :key="adKey(activeAdsByType[t], t)"
                >
                  <div class="banner__img ad-banner__media">
                    <a
                      v-if="linkIsExt(activeAdsByType[t])"
                      :href="linkExtHref(activeAdsByType[t])"
                      class="d-block h-100"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        class="ad-banner__img"
                        :src="activeAdsByType[t].image_url"
                        :alt="adPlainTitle(activeAdsByType[t].title)"
                        loading="lazy"
                        decoding="async"
                      />
                    </a>
                    <router-link
                      v-else
                      :to="linkPath(activeAdsByType[t])"
                      class="d-block h-100"
                    >
                      <img
                        class="ad-banner__img"
                        :src="activeAdsByType[t].image_url"
                        :alt="adPlainTitle(activeAdsByType[t].title)"
                        loading="lazy"
                        decoding="async"
                      />
                    </router-link>
                  </div>
                  <div class="banner__content ad-banner__content--hero">
                    <span v-if="activeAdsByType[t].tag">{{
                      activeAdsByType[t].tag
                    }}</span>
                    <h6>
                      <a
                        v-if="linkIsExt(activeAdsByType[t])"
                        :href="linkExtHref(activeAdsByType[t])"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <span
                          class="ad-banner-3d__title"
                          v-html="activeAdsByType[t].title"
                        ></span>
                      </a>
                      <router-link v-else :to="linkPath(activeAdsByType[t])">
                        <span
                          class="ad-banner-3d__title"
                          v-html="activeAdsByType[t].title"
                        ></span>
                      </router-link>
                    </h6>
                    <p v-if="activeAdsByType[t].text">
                      {{ activeAdsByType[t].text }}
                    </p>
                  </div>
                </div>
              </div>
            </AdBannerMouse3d>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import AdBannerMouse3d from './AdBannerMouse3d.vue';
import {
  adIsExternal as linkIsExt,
  adRouterPath as linkPath,
  adExternalHref as linkExtHref,
} from '@/utils/ad-media';

export default {
  components: { AdBannerMouse3d },
  props: {
    ads: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    bannerTypes123() {
      return [1, 2, 3]
    },
    activeBannerTypes123() {
      return this.bannerTypes123.filter((t) => this.activeAdsByType[t])
    },
    adsByType() {
      const groupedAds = {};
      this.ads.forEach((ad) => {
        const t = Number(ad.add_type);
        if ([1, 2, 3].includes(t)) {
          if (!groupedAds[t]) groupedAds[t] = []
          groupedAds[t].push(ad)
        }
      })
      return groupedAds
    },
    activeAdsByType() {
      const result = {}
      this.bannerTypes123.forEach((t) => {
        const list = this.adsByType[t] || []
        if (!list.length) return
        const i = Number.isFinite(this.activeIndexByType[t])
          ? this.activeIndexByType[t]
          : 0
        result[t] = list[i] || list[0]
      })
      return result
    },
  },
  data() {
    return {
      activeIndexByType: {},
      rotationMs: 3000,
      rotationIntervalId: null,
    }
  },
  watch: {
    ads: {
      immediate: true,
      deep: true,
      handler() {
        this.syncActiveIndexes()
        this.restartRotation()
      },
    },
  },
  mounted() {
    this.syncActiveIndexes()
    this.restartRotation()
  },
  beforeUnmount() {
    if (this.rotationIntervalId) {
      clearInterval(this.rotationIntervalId)
    }
  },
  methods: {
    linkIsExt,
    linkPath,
    linkExtHref,
    syncActiveIndexes() {
      this.bannerTypes123.forEach((t) => {
        const list = this.adsByType[t] || []
        if (!list.length) {
          delete this.activeIndexByType[t]
          return
        }
        const current = Number(this.activeIndexByType[t] || 0)
        this.activeIndexByType[t] = current >= list.length ? 0 : current
      })
    },
    restartRotation() {
      if (this.rotationIntervalId) {
        clearInterval(this.rotationIntervalId)
      }
      const hasMultipleAds = this.bannerTypes123.some(
        (t) => (this.adsByType[t] || []).length > 1
      )
      if (!hasMultipleAds) {
        this.rotationIntervalId = null
        return
      }
      this.rotationIntervalId = setInterval(() => {
        this.bannerTypes123.forEach((t) => {
          const list = this.adsByType[t] || []
          if (list.length > 1) {
            const i = Number(this.activeIndexByType[t] || 0)
            this.activeIndexByType[t] = (i + 1) % list.length
          }
        })
      }, this.rotationMs)
    },
    adKey(ad, type) {
      const id = ad?.id ?? ad?.ad_id ?? ad?.advertisement_id ?? ad?.image_url ?? 'ad';
      const idx = Number(this.activeIndexByType[type] || 0);
      return `${type}-${idx}-${id}`;
    },
    adPlainTitle(html) {
      if (!html || typeof html !== 'string') return '';
      return html.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
    },
  },
};
</script>

<style scoped>
/* 3D: _ad-banner-3d.scss */
.ad-rotate-swap {
  animation: ad-rotate-swap 0.55s ease both;
}

@keyframes ad-rotate-swap {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Home > below Popular Category ad cards */
.ad-banner-vertical {
  border-radius: 18px !important;
  overflow: hidden;
}

.ad-banner-vertical .ad-banner__media,
.ad-banner-vertical .ad-banner__img {
  border-radius: 18px;
}

.ad-banner-vertical .banner__content {
  background: rgba(0, 0, 0, 0.68) !important;
  backdrop-filter: blur(6px) saturate(120%) !important;
  -webkit-backdrop-filter: blur(6px) saturate(120%) !important;
  border-radius: 14px !important;
  padding: 14px 18px !important;
}
</style>